import Handlebars from 'handlebars';
import $ from 'jquery';

function render(parameters){ 
  $('#view .view__hbs').empty();
  $('#view .view__hbs').append(Handlebars.templates.TipsAndBenefitsTemplate(parameters.params));
}

export default {
  render
};
